import angular from 'angular';
import amDataService from '../data/am.data.service';
import ISharedModelService from './ISharedModel.service';


let _$filter;
let _amDataService;

export class amSharedModelService extends ISharedModelService {
  constructor(
    $filter,
    amDataService, // eslint-disable-line no-shadow
  ) {
    super('am');
    _$filter = $filter;
    _amDataService = amDataService;

    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.agencies = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.auditFields = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.coordinators = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.applicationUsers = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.technicalRisks = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.priorities = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.auditTypes = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.findingStatuses = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.recommendationStatuses = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.preparationItemStatuses = null;

    console.log('app.services.amSharedModelService created');
  }

  /** ********************************************************************************************
   *  ********************************************************************************************
   *  ********************************************************************************************
   * CRUD Operations
   *
   */

  /**
   * @typedef {Object} businessRisk
   */

  /**
   *
   * @async
   * @return {Promise<Array<businessRisk>|never>}
   */
  getBusinessRisks() {
    return _amDataService.getBusinessRisks().then(response => response.data.result);
  }

  /** ******************************************
   * RECOMMENDATION CATEGORIES
   */

  getRecommendationCategories(auditId) { // , forceRefresh = false) {
    // if (forceRefresh || !this.cache.am.recommendationCategories[auditId]) {
    // this.cache.am.recommendationCategories[auditId] = _amDataService.getRecommendationCategoriesByAudit(auditId)
    return _amDataService.getRecommendationCategoriesByAudit(auditId)
      .then(response => this.filterByCanView(
        this.sortByName(response.data.result),
      ));
    // }
    // return this.cache.am.recommendationCategories[auditId];
  }

  checkRecommendationCategoryExists(auditId, recommendationCategoryId, name) {
    return _amDataService.checkRecommendationCategoryExists(auditId, recommendationCategoryId, name)
      .then(response => response.data.result);
  }

  /** ******************************************
   * RECOMMENDATIONS
   */

  getRecommendations(recommendationCategoryId) { // , forceRefresh = false) {
    // if (forceRefresh || !this.cache.am.recommendations[recommendationCategoryId]) {
    // this.cache.am.recommendations[recommendationCategoryId] = _amDataService.getRecommendationsByRecommendationCategory(recommendationCategoryId)
    return _amDataService.getRecommendationsByRecommendationCategory(recommendationCategoryId)
      .then(response => response.data.result);
    // }
    // return this.cache.am.recommendations[recommendationCategoryId];
  }

  checkRecommendationReferenceNumberExists(auditId, recommendationId, refNum) {
    if (!refNum || refNum.length === 0) return Promise.resolve(false);
    const cleanRefNum = refNum.trim();
    // const key = `${auditId}${this.getHash(cleanRefNum)}`;
    // if (!this.cache.am.recommendationReferenceNumber[key]) {
    // this.cache.am.recommendationReferenceNumber[key] = _amDataService
    return _amDataService
      .checkRecommendationReferenceNumberExists(auditId, recommendationId, cleanRefNum)
      .then(response => response.data.result);
    // }
    // return this.cache.am.recommendationReferenceNumber[key];
  }

  saveRecommendation(recommendation) {
    // const key = this.getRecommendationNameCacheKey(recommendation);
    // this.cache.am.recommendationName[key] = Promise.resolve(true);
    if (recommendation.recommendationId > 0) {
      return _amDataService.updateRecommendation(recommendation).then(response => ({
        ...response.data,
        // NOTE: API returns model with assignedToUser set to null, so we fix that here
        assignedToUser: recommendation.assignedToUser
      }));
    }
    return _amDataService.addRecommendation(recommendation).then(response => ({
      ...response.data,
      // NOTE: API returns model with these values false, so we fix them here
      canAddNote: true,
      canAttachItems: true,
      canChangeStatus: true,
      canDelete: true,
      canEdit: true,
      canView: true,
    }));
  }

  deleteRecommendation(recommendation) {
    return _amDataService.deleteRecommendation(recommendation.recommendationId).then(() => {
      // const key = this.getRecommendationNameCacheKey(recommendation);
      // this.cache.invalidate(this.cache.am.recommendationName, key);
    });
  }

  getRecommendationNameCacheKey(recommendation) {
    const cleanName = recommendation.name.trim();
    return `${recommendation.recommendationCategoryId}${this.getHash(cleanName)}`;
  }

  /**
   * Manages querying of names as the user types so we don't flood the API endpoint
   * @public
   * @async
   * @param recommendationCategoryId
   * @param recommendationId
   * @param name
   * @returns {Promise<boolean>} - Indicates if the name already exist
   */
  checkRecommendationNameExists(recommendationCategoryId, recommendationId, name) {
    if (!name || name.length === 0) return Promise.resolve(false);
    // const key = this.getRecommendationNameCacheKey({ recommendationCategoryId, name });
    const cleanName = name.trim();
    // if (!this.cache.am.recommendationName[key]) {
    // this.cache.am.recommendationName[key] = _amDataService.checkRecommendationExists(recommendationCategoryId, recommendationId, cleanName)
    return _amDataService.checkRecommendationExists(recommendationCategoryId, recommendationId, cleanName)
      .then(response => response.data.result);
    // }
    // return this.cache.am.recommendationName[key];
  }

  /** ******************************************
   * FINDING CATEGORIES
   */

  getFindingCategories(auditId) { // , forceRefresh = false) {
    // if (forceRefresh || !this.cache.am.findingCategories[auditId]) {
    // this.cache.am.findingCategories[auditId] = _amDataService.getFindingCategoriesByAudit(auditId)
    return _amDataService.getFindingCategoriesByAudit(auditId)
      .then(response => this.filterByCanView(
        this.sortByName(response.data.result),
      ));
    // }
    // return this.cache.am.findingCategories[auditId];
  }

  checkFindingCategoryExists(auditId, findingCategoryId, name) {
    return _amDataService.checkFindingCategoryExists(auditId, findingCategoryId, name)
      .then(response => response.data.result);
  }

  /** ******************************************
   * FINDINGS
   */

  getFindings(findingCategoryId) { // , forceRefresh = false) {
    // if (forceRefresh || !this.cache.am.findings[findingCategoryId]) {
    // this.cache.am.findings[findingCategoryId] = _amDataService.getFindingsByFindingCategory(findingCategoryId)
    return _amDataService.getFindingsByFindingCategory(findingCategoryId)
      .then(response => response.data.result);
    // }
    // return this.cache.am.findings[findingCategoryId];
  }

  checkFindingReferenceNumberExists(auditId, findingId, refNum) {
    if (!refNum || refNum.length === 0) return Promise.resolve(false);
    const cleanRefNum = refNum.trim();
    // const key = `${auditId}${this.getHash(cleanRefNum)}`;
    // if (!this.cache.am.findingReferenceNumber[key]) {
    // this.cache.am.findingReferenceNumber[key] = _amDataService
    return _amDataService
      .checkFindingReferenceNumberExists(auditId, findingId, cleanRefNum)
      .then(response => response.data.result);
    // }
    // return this.cache.am.findingReferenceNumber[key];
  }

  saveFinding(finding) {
    // const key = this.getFindingNameCacheKey(finding);
    // this.cache.am.findingName[key] = Promise.resolve(true);
    if (finding.findingId > 0) {
      return _amDataService.updateFinding(finding).then(response => ({
        ...response.data,
        // NOTE: API returns model with assignedToUser set to null, so we fix that here
        assignedToUser: finding.assignedToUser
      }));
    }
    return _amDataService.addFinding(finding).then(response => ({
      ...response.data,
      // NOTE: API returns model with these values false, so we fix them here
      canAddNote: true,
      canAttachItems: true,
      canChangeStatus: true,
      canDelete: true,
      canEdit: true,
      canView: true,
    }));
  }

  deleteFinding(finding) {
    return _amDataService.deleteFinding(finding.findingId).then(() => {
      // const key = this.getFindingNameCacheKey(finding);
      // this.cache.invalidate(this.cache.am.findingName, key);
    });
  }

  getFindingNameCacheKey(finding) {
    const cleanName = finding.name.trim();
    return `${finding.findingCategoryId}${this.getHash(cleanName)}`;
  }

  /**
   * Manages querying of names as the user types so we don't flood the API endpoint
   * @public
   * @async
   * @param findingCategoryId
   * @param findingId
   * @param name
   * @returns {Promise<boolean>} - Indicates if the name already exist
   */
  checkFindingNameExists(findingCategoryId, findingId, name) {
    if (!name || name.length === 0) return Promise.resolve(false);
    // const key = this.getFindingNameCacheKey({ findingCategoryId, name });
    const cleanName = name.trim();
    // if (!this.cache.am.findingName[key]) {
    // this.cache.am.findingName[key] = _amDataService.checkFindingExists(findingCategoryId, findingId, cleanName)
    return _amDataService.checkFindingExists(findingCategoryId, findingId, cleanName)
      .then(response => response.data.result);
    // }
    // return this.cache.am.findingName[key];
  }

  /** ******************************************
   * PREPARATION ITEM CATEGORY
   */

  checkPreparationItemCategoryExists(auditId, preparationItemCategoryId, name) {
    return _amDataService.checkPreparationItemCategoryExists(auditId, preparationItemCategoryId, name)
      .then(response => response.data.result);
  }


  /** ******************************************
   * PREPARATION ITEMS
   */

  getPreparationItemCategories(auditId) { // , forceRefresh = false) {
    // if (forceRefresh || !this.cache.am.preparationItemCategories[auditId]) {
    //   this.cache.am.preparationItemCategories[auditId] = _amDataService.getPreparationItemCategoriesByAudit(auditId)
    return _amDataService.getPreparationItemCategoriesByAudit(auditId)
      .then(response => this.filterByCanView(
        this.sortByName(response.data.result),
      ));
    // }
    // return this.cache.am.preparationItemCategories[auditId];
  }

  getPreparationItems(preparationItemCategoryId) { // , forceRefresh = false) {
    // if (forceRefresh || !this.cache.am.preparationItems[preparationItemCategoryId]) {
    // eslint-disable-line max-len
    return _amDataService.getPreparationItemsByPreparationItemCategory( // eslint-disable-line max-len
      preparationItemCategoryId,
    ).then(response => response.data.result);
    // }
    // return this.cache.am.preparationItems[preparationItemCategoryId];
  }

  checkPreparationItemReferenceNumberExists(auditId, preparationItemId, refNum) {
    if (!refNum || refNum.length === 0) return Promise.resolve(false);
    const cleanRefNum = refNum.trim();
    // const key = `${auditId}${this.getHash(cleanRefNum)}`;
    // if (!this.cache.am.preparationItemReferenceNumber[key]) {
    //   this.cache.am.preparationItemReferenceNumber[key] = _amDataService
    return _amDataService
      .checkPreparationItemReferenceNumberExists(auditId, preparationItemId, cleanRefNum)
      .then(response => response.data.result);
    // }
    // return this.cache.am.preparationItemReferenceNumber[key];
  }

  savePreparationItem(preparationItem) {
    // const key = this.getPreparationItemNameCacheKey(preparationItem);
    // this.cache.am.preparationItemName[key] = Promise.resolve(true);
    if (preparationItem.preparationItemId > 0) {
      return _amDataService.updatePreparationItem(preparationItem).then(response => ({
        ...response.data,
        // NOTE: API returns model with assignedToUser set to null, so we fix that here
        assignedToUser: preparationItem.assignedToUser
      }));
    }
    return _amDataService.addPreparationItem(preparationItem).then(response => ({
      ...response.data,
      // NOTE: API returns model with these values false, so we fix them here
      canAddNote: true,
      canAttachItems: true,
      canChangeStatus: true,
      canDelete: true,
      canEdit: true,
      canView: true,
    }));
  }

  deletePreparationItem(preparationItem) {
    return _amDataService.deletePreparationItem(preparationItem.preparationItemId).then(() => {
      // const key = this.getPreparationItemNameCacheKey(preparationItem);
      // this.cache.invalidate(this.cache.am.preparationItemName, key);
    });
  }

  getPreparationItemNameCacheKey(preparationItem) {
    // NOTE: usually this is .name, but preparationItem uses .description
    const cleanName = preparationItem.description.trim();
    return `${preparationItem.preparationItemCategoryId}${this.getHash(cleanName)}`;
  }

  /**
   * Manages querying of names as the user types so we don't flood the API endpoint
   * @public
   * @async
   * @param preparationItemCategoryId
   * @param preparationItemId
   * @param description
   * @returns {Promise<boolean>} - Indicates if the name already exist
   */
  checkPreparationItemDescriptionExists(preparationItemCategoryId, preparationItemId, description) {
    if (!description || description.length === 0) return Promise.resolve(false);
    // const key = this.getPreparationItemNameCacheKey({ preparationItemCategoryId, description: name });
    const cleanName = description.trim();
    // if (!this.cache.am.preparationItemName[key]) {
    //   this.cache.am.preparationItemName[key] = _amDataService
    // this.cache.am.preparationItemName[key] = _amDataService
    return _amDataService
      .checkPreparationItemExists(preparationItemCategoryId, preparationItemId, cleanName)
      .then(response => response.data.result);
    // }
    // return this.cache.am.preparationItemName[key];
  }

  /** ******************************************
   * AGENCY
   */

  /**
   * Manages querying of names as the user types so we don't flood the API endpoint
   * @public
   * @async
   * @param agencyId
   * @param name
   * @returns {Promise<boolean>} - Indicates if the name already exist
   */
  checkAgencyNameExists(agencyId, name) {
    if (!name || name.length === 0) return Promise.resolve(false);
    const cleanName = name.trim();
    // const key = `${this.getHash(cleanName)}`;
    // if (!this.cache.am.agencyName[key]) {
    // Note checkAgencyExists(...) reverse order of params
    // this.cache.am.agencyName[key] = _amDataService.checkAgencyExists(cleanName, agencyId)
    return _amDataService.checkAgencyExists(cleanName, agencyId)
      .then(response => response.data.result);
    // }
    // return this.cache.am.agencyName[key];
  }

  saveAgency(agency) {
    // const cleanName = agency.name.trim();
    // const key = `${this.getHash(cleanName)}`;
    // this.cache.am.agencyName[key] = Promise.resolve(true);
    if (agency.agencyId > 0) {
      return _amDataService.updateAgency(agency).then(response => response.data);
    }
    return _amDataService.addAgency(agency).then(response => response.data);
  }

  deleteAgency(agency, auditId) {
    return _amDataService.deleteAgency(agency.agencyId, auditId).then(() => {
      // const cleanName = agency.name.trim();
      // const key = `${this.getHash(cleanName)}`;
      // this.cache.invalidate(this.cache.am.agencyName, key);
    });
  }

  /** **********************************************
   * FILTERS
   * TODO: delete unused filters
   */

  /**
   *
   * @param collection - array of object with canView property
   * @param {Object} propertyObject - Object containing the property to search and the desired value
   * @returns {Array<Object>}
   */
  filterByProperty(collection, propertyObject) {
    return _$filter('filter')(collection, propertyObject);
  }

  filterByCanView(collection) {
    return this.filterByProperty(collection, { canView: true });
  }

  getFindingAuditFields() {
    let findingAuditFields = null;
    if (this.auditFields) {
      findingAuditFields = _$filter('filter')(this.auditFields, { entityTypeId: 2 });
    }
    return findingAuditFields;
  }

  getAgency(agencyId) {
    let agency = null;
    if (this.agencies) {
      agency = _$filter('filter')(this.agencies, { agencyId });
    }
    return agency;
  }

  getApplicationUser(applicationUserId) {
    let applicationUser = null;
    if (this.applicationUsers) {
      applicationUser = _$filter('filter')(this.applicationUsers, { userId: applicationUserId });
    }
    return applicationUser;
  }

  getTechnicalRisk(technicalRiskId) {
    let technicalRisk = null;
    if (this.technicalRisks) {
      technicalRisk = _$filter('filter')(this.technicalRisks, { technicalRiskId });
    }
    return technicalRisk;
  }

  getPriority(priorityId) {
    let priority = null;
    if (this.priorities) {
      priority = _$filter('filter')(this.priorities, { priorityId });
    }
    return priority;
  }

  getFindingStatus(findingStatusId) {
    let findingStatus = null;
    if (this.findingStatuses) {
      findingStatus = _$filter('filter')(this.findingStatuses, { ID: findingStatusId });
    }
    return findingStatus;
  }

  getPreparationItemStatus(preparationItemStatusId) {
    let preparationItemStatus = null;
    if (this.preparationItemStatuses) {
      preparationItemStatus = _$filter('filter')(this.preparationItemStatuses, { ID: preparationItemStatusId });
    }
    return preparationItemStatus;
  }

  getAuditType(auditTypeId) {
    let auditType = null;
    if (this.auditTypes) {
      auditType = _$filter('filter')(this.auditTypes, { auditTypeId });
    }
    return auditType;
  }
}

amSharedModelService.$inject = [
  '$filter',
  'amDataService',
];

export default angular.module('app.services.amSharedModelService', [
  amDataService,
])
  .service('amSharedModelService', amSharedModelService)
  .name;
